import { superBig } from '../../../../../../../../../constants/fonts';
import { appConfig } from '../../../../../../../../../config/customization';
import { defaultPaddingLeft, mobileDefaultPaddingLeft } from '../../../../../../../../../constants/sizes';
import Device from '../../../../../../../../../constants/deviceSizes';

const container = {
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  justifyContent: 'flex-start',
  alignItems: 'flex-start'
};

export default {
  colorContainer: {
    ...container,
    backgroundColor: appConfig.colors.errorScreenBackgroundColor,
    width: '100%',
    padding: `10px ${defaultPaddingLeft}px`,
    [Device.mobile]: {
      padding: `10px ${mobileDefaultPaddingLeft}px`
    }
  },
  lineContainer: {
    ...container,
    width: `calc(100% - ${defaultPaddingLeft}px)`,
    padding: `8px 18px`,
    border: `1px solid ${appConfig.colors.bordersGray}`,
    borderRadius: 10,
    [Device.mobile]: {
      width: `calc(100% - ${mobileDefaultPaddingLeft}px)`,
      padding: 8
    }
  },
  payment: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 5
  },
  amountLabel: {
    width: '30%',
    margin: '0px 5px 5px 0',
    textAlign: 'left',
    whiteSpace: 'nowrap'
  },
  balance: {
    margin: '0px 5px 5px 0',
    textAlign: 'left',
    whiteSpace: 'no-wrap',
    [Device.tablet_desktop]: {
      width: '30%'
    },
    [Device.mobile]: {
      textAlign: 'right'
    }
  },
  amount: {
    fontSize: superBig
  },
  debtAmount: {
    color: appConfig.colors.accountBalance
  },
  buttonContainer: {
    width: '30%',
    display: 'flex',
    justifyContent: 'flex-end',
    [Device.mobile]: {
      width: '100%',
      marginTop: 5
    }
  },
  payButton: {
    width: 140,
    padding: '6px 15px',
    [Device.mobile]: {
      width: '100%',
      marginTop: 5
    }
  }
};
